var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label-base',{staticClass:"label-point-transition",attrs:{"colortype":_vm.colortype,"radius":this.radius}},[_vm._v(_vm._s(_vm.sign())+_vm._s(this.point))])}
var staticRenderFns = []

export { render, staticRenderFns }